module.exports = {
	"en": {
		"long": {
			"day": "numeric",
			"hour": "numeric",
			"minute": "numeric",
			"month": "short",
			"weekday": "short",
			"year": "numeric"
		},
		"short": {
			"day": "2-digit",
			"month": "2-digit",
			"year": "2-digit"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./hileadzz_i18n/hileadzz/datetime.yml
// module id = 2025
// module chunks = 0